<div class="card">
    <div *ngIf="showSpinner" class="dashboard-charts p-d-flex">
        <app-block-content-spinner  height="100%" style="width: 100%"></app-block-content-spinner>
    </div>
    <div class="p-grid">
        <div class="p-col-12" #content>
          <ng-container *ngIf="chartType == 'image'">
              <div *ngIf="chartData && chartData?.length > 0" class="p-text-center">
                  <img [src]="chartData" [style.max-height.px]="contentHeight" style="width: 100%;">
              </div>
              <p *ngIf="(!chartData || chartData?.length == 0) && !showSpinner">
                    No data found!
              </p>
          </ng-container>
        </div>
    </div>
  </div>
